import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { GalaxyEvent, } from '@datapad/data-model';
import { assert, assertDefined } from '@datapad/utilities';
import { useTree } from '@fluidframework/react/alpha';
import { Box, Card, Grid, Typography } from '@mui/material';
import { Tree } from 'fluid-framework';
import React from 'react';
import { EditableCalendarDateView } from './CalendarDateField.js';
import { CharacterList } from './CharacterList.js';
import { ConfirmationDialogue } from './ConfirmationDialogue.js';
import { EditableListView } from './EditableListView.js';
import { MaybeLocationView } from './LocationView.js';
import { TextField } from './TextField.js';
var ModalState;
(function (ModalState) {
    ModalState[ModalState["None"] = 0] = "None";
    ModalState[ModalState["Deleting"] = 1] = "Deleting";
})(ModalState || (ModalState = {}));
export function CalendarEventView(props) {
    const { event, canEdit, deleteEvent, linkToCalendar, getCharacter, linkToCharacter } = props;
    useTree(event);
    const [modalState, setModalState] = React.useState(ModalState.None);
    const maybeModal = modalState === ModalState.Deleting ? (_jsx(ConfirmationDialogue, { message: `Are you sure you want to delete the event "${event.title}"?\nThis action cannot be undone.`, onConfirm: () => {
            assert(canEdit, 'Tried to delete event when not allowed to edit');
            assertDefined(deleteEvent, 'Tried to delete event but no deleteEvent callback was provided.');
            deleteEvent();
            setModalState(ModalState.None);
        }, onCancel: () => setModalState(ModalState.None) })) : (_jsx(_Fragment, {}));
    const entries = [];
    entries.push(_jsx(LabeledEntry, { label: "Title", children: _jsx(TextField, { value: event.title, onChange: (updatedValue) => (event.title = updatedValue) }) }, "title"));
    entries.push(_jsx(EditableCalendarDateView, { date: event.date, linkToCalendar: linkToCalendar }));
    entries.push(_jsx(LabeledEntry, { label: "Description", children: _jsx(TextField, { value: event.description ?? '', onChange: (updatedValue) => (event.description = updatedValue), multiline: true }) }, "description"));
    entries.push(_jsxs(LabeledEntry, { label: "Location", children: [_jsx(MaybeLocationView, { location: event.location, canEdit: canEdit, missingLocationText: "No location set" }, "location"), ","] }, "location"));
    const characters = event.characters.map(getCharacter);
    entries.push(_jsx(LabeledEntry, { label: "Characters", children: _jsx(CharacterList, { characters: characters, onClick: linkToCharacter }) }, "characters"));
    if (Tree.is(event, GalaxyEvent)) {
        entries.push(_jsx(LabeledEntry, { label: "Involved Factions", children: _jsx(EditableListView, { list: event.involvedFactions, view: (faction) => _jsx(Typography, { children: faction }), getKeyForItem: (faction) => faction }) }, "factions"));
    }
    return (_jsxs(Grid, { children: [maybeModal, entries] }));
}
function LabeledEntry(props) {
    const { children, label } = props;
    return (_jsx(Card, { children: _jsxs(Box, { textAlign: 'left', children: [_jsx(Typography, { variant: "body1", children: label ? _jsxs("b", { children: [label, ": "] }) : _jsx(_Fragment, {}) }), children] }) }));
}
//# sourceMappingURL=CalendarEventView.js.map